module.exports = __webpack_public_path__ + "img/bank-24-kbank.d9490749.svg";